import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromDetectionLabel from './detection-label.reducer';


// get the selectors
const {
  selectEntities,
  selectAll,
} = fromDetectionLabel.adapter.getSelectors();

export const selectDetectionLabelState = createFeatureSelector<fromDetectionLabel.State>('detectionLabels');


export const selectDetectionLabelEntities = createSelector(
  selectDetectionLabelState,
  selectEntities
);
export const selectAllDetectionLabels = createSelector(
  selectDetectionLabelState,
  selectAll
);

export const selectDetectionLabelText = (key: string) =>
  createSelector(
    selectDetectionLabelEntities,
    entities => entities[key]?.label ?? key
  );
export const selectDetectionLabelOptions = createSelector(
  selectAllDetectionLabels,
  labels =>
    labels.map(label => ({
      value: label.key,
      label: label.label,
    }))
);
